__webpack_require__.p = "https://j1.58cdn.com.cn/git/hrg-fe/zp-tongzhen/app-mini-card/";